// Union type for all possible Stripe payment method types
export type StripePaymentMethodType = 
  | 'card' 
  | 'us_bank_account';

// Base payment method interface
export interface BasePaymentMethod {
  id: string;
  type: StripePaymentMethodType;
}

// Card payment method interface
export interface CardPaymentMethod extends BasePaymentMethod {
  type: 'card';
  brand?: string;
  expMonth?: number;
  expYear?: number;
  last4?: string;
}

// US Bank Account payment method interface
export interface UsBankAccountPaymentMethod extends BasePaymentMethod {
  type: 'us_bank_account';
  bankName?: string;
  accountHolderType?: string;
  accountType?: string;
  routingNumber?: string;
  last4?: string;
}

// Union type for all payment methods
export type PaymentMethod = CardPaymentMethod | UsBankAccountPaymentMethod;

// Type guard for card payment method
export const isCardPaymentMethod = (
  method: PaymentMethod
): method is CardPaymentMethod => method.type === 'card';

// Type guard for US bank account payment method
export const isUsBankAccountPaymentMethod = (
  method: PaymentMethod
): method is UsBankAccountPaymentMethod => method.type === 'us_bank_account';
